module.exports = __webpack_public_path__ + "static/media/landline_phone.559ec4ae.svg";